class NoticePopup extends HTMLElement {
  constructor() {
    super();

    this.cookieName = 'notice-popup';
    this.delay = parseInt(this.getAttribute('data-delay'), 10) || 0;
    this.expireDays = parseInt(this.getAttribute('data-expire'), 10) || 1;

    this.scheduleEnabled = String(this.getAttribute('data-schedule')) === 'true';
    this.start = (this.getAttribute('data-start') || '').trim(); // YYYY-MM-DD
    this.end = (this.getAttribute('data-end') || '').trim();     // YYYY-MM-DD

    this._onBodyClick = this.onBodyClick.bind(this);

    // 1) Se já fechou (cookie), não exibe
    if (this.getCookie(this.cookieName) !== '') return;

    // 2) Se tem período, valida janela
    if (this.scheduleEnabled && !this.isWithinSchedule()) return;

    // 3) Bind de fechar
    this.querySelectorAll('[data-close-notice-popup]').forEach((el) => {
      el.addEventListener('click', () => this.close());
    });

    document.body.addEventListener('click', this._onBodyClick);

    // 4) Exibir após delay
    window.setTimeout(() => {
      this.open();
    }, this.delay);
  }

  isWithinSchedule() {
    // Se start/end estiverem vazios, considera válido
    if (!this.start && !this.end) return true;

    const now = new Date();

    const startDate = this.start ? new Date(this.start + 'T00:00:00') : null;
    const endDate = this.end ? new Date(this.end + 'T23:59:59') : null;

    if (startDate && now < startDate) return false;
    if (endDate && now > endDate) return false;

    return true;
  }

  open() {
    this.classList.add('is-open');
  }

  close() {
    this.setCookie(this.cookieName, 'closed', this.expireDays);
    this.classList.remove('is-open');

    // limpa listener
    document.body.removeEventListener('click', this._onBodyClick);
  }

  onBodyClick(event) {
    // clique fora do painel fecha
    const panel = this.querySelector('.halo-notice-popup__panel');
    if (!panel) return;

    if (this.classList.contains('is-open') && !panel.contains(event.target)) {
      // evita fechar se clicou em algo interno ao componente (overlay/painel já tratado)
      // mas como overlay é irmão, o contains falha -> fecha corretamente
      this.close();
    }
  }

  setCookie(cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    const expires = 'expires=' + d.toUTCString();
    document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
  }

  getCookie(cname) {
    const name = cname + '=';
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') c = c.substring(1);
      if (c.indexOf(name) === 0) return c.substring(name.length, c.length);
    }
    return '';
  }
}

customElements.define('notice-popup', NoticePopup);
